
import AnnouncementModals from "@/Modals/ContentManagement/Announcements/Modal";
import { announcementsApi } from "@/apis/apis";
import BaseTable from "./BaseTable";
import { columns } from "./Columns";

export default function AnnouncementsPage() {
  return (
    <BaseTable
      label="Announcement"
      apiURL={announcementsApi}
      columns={columns()}
      ModalComponent={AnnouncementModals}
      importData={null}
      enableSortData={true}
      confirmationModalTitleKey="text"
    />
  );
}
